 /*const editorOption = {
    modules: {
        toolbar: [
            ["bold", "italic", 'underline', 'strike', "link", "blockquote"],
            [
                { list: "ordered" }, { list: "bullet" }, { script: "sub" }, { script: "super" }, { indent: '-1' }, { indent: '+1' },
                { size: ['small', 'medium', 'large', 'huge'] }, { header: [1, 2, 3, 4, 5, 6, false] }, { color: [] }, { align: [] }
            ],
            ['clean']
        ]
    },
    theme: "snow"
};

const blockOptions = {
    message: '<div class="fa fa-spin fa-circle-o-notch fa-fw fa-2x"></div>',
    overlayCSS: {
        backgroundColor: '#fff',
        opacity: 0.8,
        cursor: 'wait'
    },
    css: {
        border: 0,
        padding: 0,
        backgroundColor: 'transparent'
    }
};*/

const appSettings = {
    
        editorOption: {
            modules: {
                toolbar: [
                    ["bold", "italic", 'underline', 'strike', "link", "blockquote"],
                    [
                        { list: "ordered" }, { list: "bullet" }, { script: "sub" }, { script: "super" }, { indent: '-1' }, { indent: '+1' },
                        { size: ['small', 'medium', 'large', 'huge'] }, { header: [1, 2, 3, 4, 5, 6, false] }, { color: [] }, { align: [] }
                    ],
                    ['clean']
                ]
            },
            theme: "snow"
        },
        blockOptions: {
            message: '<div class="fa fa-spin fa-circle-o-notch fa-fw fa-2x"></div>',
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'transparent'
            }
        }
};

export default appSettings


  


// WEBPACK FOOTER //
// ./src/assets/js/editorsettings.js